import { ParseNumber } from "../../../../../global";
import { NumberFormat } from "../../../utils/tools";
import { SingletonEnginnering } from "../singletonEngineering";
import ValueOnStrucutre from "./valueOnStructureEnginnering";

const Validators = {
  mappings: new Map(),
  readOnly: false,
  valuesIsErrors: ["-9999", "-9999,0", "-9.999,0", "-9.999", "", null, undefined],
  IsValidXML: function(xmlString){
    let parser = new DOMParser();
    try{ 
      let xmlParsed = parser.parseFromString(xmlString,"text/xml");
      return xmlParsed.getElementsByTagName('parsererror').length ? false : true 
    } catch(error){
      return false;
    }
  },

  CheckProblemsInEnginneringMapping: function(tableFlowChart){
    // eslint-disable-next-line no-unused-vars
    let filteredList = []
    if(!Array.isArray(tableFlowChart)){
      return filteredList
    }
    tableFlowChart.forEach((element)  => {
      let blockThisItem = false

      if(!element.item || this.valuesIsErrors.includes(element.value) || !this.EnginneringMappingItemIsOk(element.item)){
        blockThisItem = true
      }

      element.value = this.removeDotInValue(element.value)

      let oldValue = SingletonEnginnering.getPropertieByToken(element.item);
      let oldParsedValue = ValueOnStrucutre.get(SingletonEnginnering.structureOfEnginneringStatic, oldValue);



      if(!blockThisItem && !this.valueWasChanged(element.item, element.value)) {
        blockThisItem = true
      }

      
      if(!blockThisItem && !this.uniqueMapping(element)){
        blockThisItem = true
      }
      
      if (!blockThisItem) {
        filteredList.push({
            ...JSON.parse(JSON.stringify(element)),
            oldValue: oldParsedValue // Adicionar o valor antigo ao elemento
        });
    }
    })
    this.mappings.clear();
    return filteredList
  },

  removeDotInValue: value => value.replace(/\./g,''),

  EnginneringMappingItemIsOk: function(item){

    if(!item){
      //console.log('EnginneringMappingItemIsOk - Impossível analisar o item :>> ', item)
      return false
    }
  
    const types = ["cr", "op" , "cp", "in", "ci", "eq"]
    let itemParts = item.split("|")
  
    if(!types.includes(itemParts[0])){
      //console.log('EnginneringMappingItemIsOk - Engenharia - Tipo não mapeado :>> ', itemParts[0])
      return false
    }
  
    itemParts.forEach( part => {
      if(!part) {
        //console.log('EnginneringMappingItemIsOk - Item possui parte com valor vazio !! :>> ', item)
        return false
      }
    })
  
    if(itemParts[0] == "op"){
      return itemParts.length == 4 ? true : false
    }
  
    if(itemParts[0] == "cr" || itemParts[0] == "cp"){
      return itemParts.length == 4 ? true : false
    }
  
    if(itemParts[0] == "in" || itemParts[0] == "ci" ){
      return itemParts.length == 5 ? true : false
    }

    if(itemParts[0] == "eq" ){
      return itemParts.length == 5 || itemParts.length == 4 
    }
  
    return false
  },

  uniqueMapping(element){
    if(!this.mappings.has(element.item)){
      this.mappings.set(element.item, element.value)
      return true;
    }
    return false
  },

  sendLog(message){
    if(!this.readOnly){
      console.log("ATENÇÃO: " + message);
    }
  },

  valueWasChanged(mapping, valueToEdit){
    let prop = SingletonEnginnering.getPropertieByToken(mapping)
    let value = ValueOnStrucutre.get(SingletonEnginnering.structureOfEnginneringStatic, prop)
    
    //console.log(`Mapping: ${mapping}`, valueToEdit, value);
    
    if(ParseNumber(NumberFormat(value)) != ParseNumber(valueToEdit) || this.valueIsBooleanAndChanged(value, valueToEdit)){
      console.log(`Mapeamento: [${mapping}], Editado: [${valueToEdit}], Anterior: [${value}]`);
      return true
    }
    return false;
  },

  valueIsBooleanAndChanged(value, valueToEdit){
    if ((value == "true" || value == "false") && (valueToEdit == "true" || valueToEdit == "false")){
      if(value != valueToEdit){
        return true
      }
    }
    return false
  }
}

export default Validators